
function quickValidSKU(whicheye) {
	//If no skulist, don't try to validate /
	if(typeof skulist === 'undefined' || !skulist.length || skulist == 'no skus') {
		return true;
	}
	var opts = document.getElementsByTagName('select');
	var sku = '';
	for(var i=0; i<opts.length; i++) {
		var opt = opts[i];
		if(opt.id && opt.id.indexOf('option') != -1) {
			if((whicheye == 1 && opt.id.indexOf('optionB') == -1) || (whicheye == 2 && opt.id.indexOf('optionB') > -1)) {
				sku += buildAbbr(opt);
			}
		}
	}
	//check for valid sku /
	if(skulist.indexOf(sku) == -1) {
		return false;
	}
	return true;
}

// Validation to prevent "--" options being added to basket /
// and warn about invalid option combinations  /
//callfor validate different power and base curve only when add to basket is clicked on
function validateOptions(check_for) {
	var units = getObById('units');
	var eyes = $('input[name=units]:checked', '#addtobasket').val();
	var opts = document.getElementsByTagName('select');
	var error = new Array;
	var skua = '';
	var skub = '';
	var incA = false;
	var incB = false;
	var emptyerror = false;
	var leftempty = false;
	var rightempty = false;
	var comboerror = false;
	var leftcombo = false;
	var rightcombo = false;
	var prefix = '';
	var eye = 0;
	ready = true;
	
	//process each option /
	for(var i=0;i<opts.length;i++) {
		var opt = opts[i];
		var optValue = $.trim($(opt).find('option:selected').text());

		//check to ensure select is a product option / 
		if(opt.id && opt.id.indexOf('option') != -1) {
			opt.style.borderColor = '#dddddd';
			if(opt.className != 'disabled') {
				opt.style.backgroundColor = '#ffffff';
			}
			
			//set the eye prefix /
			if(eyes == 2) {
				if(opt.id.indexOf('optionB') == -1) {
					prefix = '<strong>'+ leftEye + ':</strong> ';
					eye = 1;
					skua += buildAbbr(opt);
					// Get the power for left eye
					if(oh[opt.title].abbr == 'p') {
						var power1_value = optValue;
						var power1 = opt;
					}
					// Get the basecurve for left eye
					if(oh[opt.title].abbr == 'bc') {
						var basecurve1_value = optValue;
						var basecurve1 = opt;
					}
				} else {
					prefix = '<strong>' + rightEye + ':</strong> ';
					eye = 2;
					skub += buildAbbr(opt);
					// Get the power for right eye
					if(oh[opt.title].abbr == 'p') {
						var power2_value = optValue;
						var power2 = opt;
					}
					// Get the basecurve for left eye
					if(oh[opt.title].abbr == 'bc') {
						var basecurve2_value = optValue;
						var basecurve2 = opt;
					}
				}
			} else if(opt.id.indexOf('optionB') == -1) {
				prefix = '';
				eye = -1;
				skua += buildAbbr(opt);
			} else {
				eye = 0;
			}
			
			//check for blank option "--" /
			if(optValue == "--") {
				colorError(opt.id,r,g,b);
				if((eye == -1 && emptyerror == false) || (eye == 1 && leftempty == false) || (eye == 2 && rightempty == false)) {
					error[error.length + 1] = (prefix + emptymsg + '<br />');
					emptyerror = true;
					if(eye == -1 || eye == 1) {
						leftempty = true;
					} else if(eye == 2) {
						rightempty = true;
					}
					ready = false;
				}
			}
		}
	}
	
	//If we don't use SKUs we can stop now /
	if(typeof skulist === 'undefined' || skulist === undefined  || skulist.length == 0 || skulist == "no skus") {
		error = errorString(error);
		return feedback(ready,error);
	}
	//end option loop /
	//check for valid sku on first product /
	if(skulist.indexOf(skua) == -1 && leftempty == false) {
		//Color the active options /
		for(var i=0;i<opts.length;i++) {
			var opt = opts[i];
			if(opt.id && opt.id.indexOf('option') != -1 && opt.id.indexOf('optionB') == -1 && opt.className != 'disabled') {
				colorError(opt.id,r,g,b);
			}
		}
		//set the eye prefix /
		if(eyes == 2) {
			prefix = '<strong>' + leftEye + ':</strong> ';
		} else {
			prefix = '';
		}
		error[error.length + 1] = (prefix + combomsg + '<br />');
		GA_Event_Trigger("Product", "Notification", "Invalid SKU");
		ready = false;
	}
	
	//check for valid sku on second /
	if(skub != '' && skulist.indexOf(skub) == -1 && rightempty == false) {
		//Color the active options /
		for(var i=0;i<opts.length;i++) {
			var opt = opts[i];
			if(opt.id && opt.id.indexOf('optionB') != -1 && opt.className != 'disabled') {
				colorError(opt.id,r,g,b);
			}
		}
		//set the prefix /
		prefix = '<strong>' + rightEye + ':</strong> ';
		error[error.length + 1] = (prefix + combomsg + '<br />');
		GA_Event_Trigger("Product", "Notification", "Invalid SKU");
		ready = false;
	}
	//done /
	
	//Only check this if adding to the basket
	if(check_for == 'basket') {
		// If there is not already an error check the two powers and warn the customer that they are different
		if(ready != false && ('undefined' !== typeof(differentPowers)) && power1_value && power2_value && power1_value != '0.00' && power2_value != '0.00') {
			if(power1_value.substr(0, 1) != power2_value.substr(0, 1)) {
				rememberPrescriptionWarning('p');
				GA_Event_Trigger("Product", "Notification", "Plus and minus conflict");
				if(confirm(differentPowers)) {
					ready = true;
				} else {
					colorError(power1.id,r,g,b);
					colorError(power2.id,r,g,b);
					ready = false;
				}
			}	
		}
	
		// If there is not already an error check the two basecurves and warn the customer that they are the same
		if(ready != false && ('undefined' !== typeof(differentBaseCurve)) && basecurve1_value && basecurve2_value) {
			if(basecurve1_value != basecurve2_value) {
				rememberPrescriptionWarning('bc');
				GA_Event_Trigger("Product", "Notification", "Basecurve Mismatch");
				if(confirm(differentBaseCurve)) {
					ready = true;
				} else {
					colorError(basecurve1.id,r,g,b);
					colorError(basecurve2.id,r,g,b);
					ready = false;
				}
			}	
		}
	}
	
	error = errorString(error);
	return feedback(ready,error);
	
}

//Handle output of errors / submit form /
function feedback(ready,error) {
	if(ready == true) {
		return true;
	} else {
		// We may set ready to false, but not have an associated error, e.g. different base curves or +ve and -ve powers. Only display error box if there are actual errors.
		if(error) {
			var $messageElement = $("#jsErrors");
			if($messageElement.hasClass("js-wrap-in-paragraph")) {
				var paragraphContainer = $("<p />");
				error = paragraphContainer.append(error);
			}
			$messageElement.html(error);
			$messageElement.show();
	    var serr = getObById('serverErrors');
	    if(serr) {
	      serr.style.display = 'none';
	    }
	  }
		return false;
	}
}

//Helper for building option name->abbr lookup hash object /
function okv(name,abbr) {
	this.name = name;
	this.abbr = abbr;
}

//Build option _abbreviate-value string
function buildAbbr(el) {
	// oh - declared in templates from {OPT_HASH}
	var elValue = $.trim($(el).find('option:selected').text());

	if(oh[el.title]['abbr'] == 'co') {
		var optionSelectValue = colourCodes[elValue];
	} else {
		var optionSelectValue = elValue;
	}
	if(optionSelectValue == '--') {
		optionSelectValue = '';
	}
	var abval = "_" + oh[el.title].abbr + $.trim(optionSelectValue);

	return abval;
}

//Helper to sort errors and convert to string / 
function errorString(msg) {
	msg = msg.sort();
	msg = msg.reverse();
	msg = msg.join(" ");
	return msg;
}



